import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import './eiq-live-activity.scss';
import eiqManageLiveActivityStore from 'features/eiq-manage/stores/live-activity.store';
import configurationStore from 'common/stores/configuration/configuration.store';
import { LiveActivityFeed } from 'common/components/live-activity/live-activity-feed';
import { Select } from 'antd';

export const EiqLiveActivity = observer(() => {
  const [locations, setLocations] = useState<any>([]);

  useEffect(() => {
    const options =
      configurationStore.configuration?.gates.map((g) => {
        return {
          label: g.name,
          value: g.name,
        };
      }) ?? [];

    setLocations([{ label: 'All', value: 'All' }, ...options]);

    eiqManageLiveActivityStore.init();
  }, []);

  const onLocationChanged = (value: any) => {
    const newValue = value === 'All' ? null : value;
    eiqManageLiveActivityStore.setLocation(newValue);
  };

  return (
    <LiveActivityFeed
      logs={eiqManageLiveActivityStore.logs}
      filter={
        <div className="location-wrapper">
          <span>Location</span>
          <Select defaultValue="All" options={locations} placeholder="Select location" onChange={onLocationChanged} />
        </div>
      }
    />
  );
});
